/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { InnerBlocks, RichText } from '@wordpress/block-editor';
import { isEmpty, has } from 'lodash';

/**
 * Inner dependencies.
 */
import BaseWrapper from '../../components/base-wrapper';

export default function save( props ) {
	const { attributes } = props;
	const { title, layout, columnSize, className, align, blockAdvanceOptions } = attributes;

	const titleStyle = {
		color: 'inherit',
	};
	if ( has( blockAdvanceOptions, 'textColor' ) && ! isEmpty( blockAdvanceOptions.textColor ) ) {
		titleStyle.color = blockAdvanceOptions.textColor;
	}

	const wrapperClasses = classnames(
		className,
		`align${ align }`,
		`gutenify-team-block-wrapper gutenify-team-${ layout }`,
		`gutenify-team-col-${ columnSize }`
	);
	return (
		<div className={ wrapperClasses }>
			<BaseWrapper { ...props } name="gutenify/team">
				<RichText.Content tagName="h2" value={ title } className="gutenify-team-block-title" style={ titleStyle } />
				<div className="gutenify-team-block">
					<InnerBlocks.Content />
				</div>
			</BaseWrapper>
		</div>

	);
}

